import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import BottomNav from './BottomNav';
import { useSettings } from '../contexts/SettingsContext';
import { useMediaQuery } from '../hooks/useMediaQuery';

const Layout: React.FC = () => {
    const { settings } = useSettings();
    const isDesktop = useMediaQuery('(min-width: 768px)');

    const navLayout = isDesktop ? settings.desktopNavLayout : settings.mobileNavLayout;

    return (
        <div className={`bg-gray-50 dark:bg-gray-900 min-h-screen`}>
            {navLayout === 'top' ? <Header /> : <div />}
            <main className={`mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8 ${navLayout === 'bottom' ? 'pb-24' : ''}`}>
                <Outlet />
            </main>
            {navLayout === 'bottom' ? <BottomNav /> : <div />}
        </div>
    );
};

export default Layout;